export const environment = {
  production: false,
  API_URL: 'https://d3v.mobirel-bridge.com/mobi-api',
  SOCKET_URL: 'https://d3v.mobirel-bridge.com',
  version: require('../../package.json').version + '.dev',
  PAGE_TITLE: 'Mobirel App - Dev',

  showUEFinanceBanner: true,

  // Times in seconds
  authAnimationTime: 2, // Loading Animation on Login Success
  minLoadingDataTime: 0.3, // Minimal time to load data, prevents immediate disappearance of the loading spinner etc.

  APP_NAME: 'Mobirel App - Dev',
  APP_URL: 'https://d3v.mobirel-bridge.com/',

  GOOGLE_ANALYTICS_ENABLED: false,
  GOOGLE_ANALYTICS_GTAG: '',
  ENABLED_PAYMENT_METHODS_GROUPS: [
    'fasttransfers',
    'blik',
    'wallet',
    'credit card',
    'google pay',
    'apple pay',
    'Installments',
  ],

  OPEN_REPLAY_ENABLED: false,
  OPEN_REPLAY_PROJECT_KEY: '',

  PRIVACY_POLICY_PDFS: {
    pl: 'https://kartapobytu.app/privacy-policy-PL.pdf',
    en: 'https://kartapobytu.app/privacy-policy-EN.pdf',
    uk: 'https://kartapobytu.app/privacy-policy-UKR.pdf',
    ru: 'https://kartapobytu.app/privacy-policy-RU.pdf',
  },

  TOS_PDFS: {
    pl: 'https://kartapobytu.app/tos-pl.pdf',
    en: 'https://kartapobytu.app/tos-en.pdf',
    uk: 'https://kartapobytu.app/tos-ukr.pdf',
    ru: 'https://kartapobytu.app/tos-ru.pdf',
  },

  DATA_LISTING_REQUEST_PROCESSING_BUSINESS_DAYS: 5,

  CANDVERIF: {
    CSS: 'debmobidevcandverificationsystem',
    PVS: 'feverysecretpinverificationsecretooasoo',
    FS: 'ooassooverysecretyformsecret',
    PL: 5,
    MA: 3,
  },

  OFFICE_VISITS: {
    MIN_HOUR: '07:30', // FIRST OPTION -> 7:30
    MAX_HOUR: '18:00', // LAST OPTION -> 17:30
    SLOT_TIME: 30, // MINUTES
  },
};
